import * as React from 'react';

const SvgUpdateWhatsapp = (props) => (
  <svg
    viewBox='0 0 36 36'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18 34.875c8.698 0 15.75-7.052 15.75-15.75S26.698 3.375 18 3.375 2.25 10.427 2.25 19.125c0 2.825.744 5.476 2.046 7.768L2.25 34.875l8.23-1.908A15.68 15.68 0 0 0 18 34.875Zm0-2.423c7.36 0 13.327-5.967 13.327-13.327S25.36 5.798 18 5.798 4.673 11.765 4.673 19.125c0 2.842.89 5.476 2.405 7.639L5.885 31.24l4.555-1.138a13.265 13.265 0 0 0 7.56 2.35Z'
      fill='#BFC8D0'
    />
    <path
      d='M31.5 18c0 7.456-6.044 13.5-13.5 13.5-2.844 0-5.482-.88-7.658-2.38l-4.615 1.153 1.21-4.535A13.438 13.438 0 0 1 4.5 18c0-7.456 6.044-13.5 13.5-13.5S31.5 10.544 31.5 18Z'
      fill='url(#updateWhatsapp_svg__a)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18 33.75c8.698 0 15.75-7.052 15.75-15.75S26.698 2.25 18 2.25 2.25 9.302 2.25 18c0 2.825.744 5.476 2.046 7.768L2.25 33.75l8.23-1.908A15.68 15.68 0 0 0 18 33.75Zm0-2.423c7.36 0 13.327-5.967 13.327-13.327S25.36 4.673 18 4.673 4.673 10.64 4.673 18c0 2.842.89 5.476 2.405 7.639l-1.193 4.476 4.555-1.138a13.265 13.265 0 0 0 7.56 2.35Z'
      fill='#fff'
    />
    <path
      d='M14.063 10.688c-.375-.753-.95-.686-1.53-.686-1.037 0-2.654 1.242-2.654 3.554 0 1.895.835 3.97 3.649 7.072 2.715 2.995 6.283 4.544 9.245 4.491 2.961-.053 3.57-2.601 3.57-3.462 0-.382-.236-.572-.4-.624-1.008-.484-2.87-1.387-3.294-1.556-.423-.17-.644.06-.782.184-.384.366-1.145 1.445-1.406 1.688-.26.242-.65.12-.811.028-.595-.239-2.21-.957-3.496-2.204-1.59-1.542-1.684-2.073-1.984-2.545-.24-.378-.063-.61.024-.711.343-.396.816-1.006 1.029-1.31.212-.303.043-.764-.058-1.05-.434-1.235-.803-2.268-1.102-2.87Z'
      fill='#fff'
    />
    <defs>
      <linearGradient
        id='updateWhatsapp_svg__a'
        x1={29.813}
        y1={7.875}
        x2={4.5}
        y2={31.5}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#5BD066' />
        <stop offset={1} stopColor='#27B43E' />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgUpdateWhatsapp;
